import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaMapMarkerAlt, FaEnvelope, FaGlobe, FaExternalLinkAlt, FaInstagram, FaWhatsapp } from 'react-icons/fa';

function Footer() {
  const logos = [
    {
      url: 'https://customer-assets.emergentagent.com/job_a43c09e4-6488-4f9a-bb3b-a0193cc08877/artifacts/jz8bmnvw_IMG-20251109-WA0011.jpg',
      alt: 'پارک علم و فناوری مازندران',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_a43c09e4-6488-4f9a-bb3b-a0193cc08877/artifacts/wq0uent2_IMG-20251109-WA0006.jpg',
      alt: 'قطب علمی بنیادی',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_a43c09e4-6488-4f9a-bb3b-a0193cc08877/artifacts/uv599fs2_IMG-20251109-WA0007.jpg',
      alt: 'لوگو دانا',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_a43c09e4-6488-4f9a-bb3b-a0193cc08877/artifacts/ge7umnu6_IMG-20251109-WA0008.jpg',
      alt: 'جمهوری اسلامی ایران',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_a43c09e4-6488-4f9a-bb3b-a0193cc08877/artifacts/22vepv2m_IMG-20251109-WA0009.jpg',
      alt: 'مرکز کارآفرینی بین المللی دانشگاه شمال',
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_noavarinshow/artifacts/r9h2056r_IMG-20251109-WA0010.jpg',
      alt: 'دانشگاه شمال',
    },
  ];

  return (
    <footer className="relative bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950 border-t-4 border-secondary-500 dark:border-secondary-600 transition-colors duration-300 py-12" data-testid="footer">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        {/* Logos Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-12 pb-8 border-b-2 border-white/20"
        >
          <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-8">
            حامیان و همکاران
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {logos.map((logo, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.1, y: -5 }}
                className="bg-white rounded-2xl p-4 shadow-xl hover:shadow-2xl transition-all duration-300 flex items-center justify-center"
              >
                <img
                  src={logo.url}
                  alt={logo.alt}
                  className="w-full h-20 object-contain"
                  loading="lazy"
                />
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Social Media Links - New Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mb-12 pb-8 border-b-2 border-white/20"
        >
          <h3 className="text-2xl md:text-3xl font-bold text-center text-white mb-6">
            ما را دنبال کنید
          </h3>
          <div className="flex justify-center gap-4 md:gap-6">
            <motion.a
              href="https://www.instagram.com/noafarin.sho?igsh=czNtaThwcnhhc213"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -5 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-3 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-700 hover:to-purple-700 text-white px-6 py-4 rounded-2xl font-bold text-base md:text-lg shadow-xl hover:shadow-2xl transition-all"
              data-testid="instagram-link"
            >
              <FaInstagram className="text-2xl" />
              <span>اینستاگرام نوآفرین‌شو</span>
            </motion.a>
            
            <motion.a
              href="https://whatsapp.com/channel/0029VbC2x05GJP8J3AEa4V1N"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, y: -5 }}
              whileTap={{ scale: 0.95 }}
              className="flex items-center gap-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white px-6 py-4 rounded-2xl font-bold text-base md:text-lg shadow-xl hover:shadow-2xl transition-all"
              data-testid="whatsapp-link"
            >
              <FaWhatsapp className="text-2xl" />
              <span>کانال واتساپ</span>
            </motion.a>
          </div>
        </motion.div>

        {/* Contact Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
          <motion.div
            whileHover={{ y: -5 }}
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:border-secondary-500 transition-all"
          >
            <FaMapMarkerAlt className="text-4xl text-secondary-400 mb-3" />
            <h3 className="font-bold text-white text-lg mb-2">آدرس</h3>
            <p className="text-gray-200 text-sm leading-relaxed">مازندران، آمل، کیلومتر ۵ جاده هراز</p>
            <p className="text-gray-200 text-sm">سه راهی امامزاده عبدالله</p>
            <p className="text-secondary-300 text-sm mt-2 font-semibold">کدپستی: 4616110038</p>
          </motion.div>

          <motion.div
            whileHover={{ y: -5 }}
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:border-secondary-500 transition-all"
          >
            <FaPhone className="text-4xl text-secondary-400 mb-3" />
            <h3 className="font-bold text-white text-lg mb-2">تماس</h3>
            <p className="text-gray-200 text-sm">۰۹۱۲۲۱۶۰۱۶۵</p>
            <p className="text-gray-200 text-sm">۰۱۱-۴۴۴۴۰۷۰۴</p>
          </motion.div>

          <motion.div
            whileHover={{ y: -5 }}
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:border-secondary-500 transition-all"
          >
            <FaGlobe className="text-4xl text-secondary-400 mb-3" />
            <h3 className="font-bold text-white text-lg mb-2">وب‌سایت</h3>
            <a 
              href="https://karafarini.shomal.ac.ir" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-secondary-300 text-sm hover:text-secondary-200 transition-colors block underline"
            >
              karafarini.shomal.ac.ir
            </a>
          </motion.div>

          <motion.div
            whileHover={{ y: -5 }}
            className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:border-secondary-500 transition-all"
          >
            <FaEnvelope className="text-4xl text-secondary-400 mb-3" />
            <h3 className="font-bold text-white text-lg mb-2">پشتیبانی</h3>
            <p className="text-gray-200 text-sm">مرکز رشد و کارآفرینی</p>
            <p className="text-gray-200 text-sm">دانشگاه شمال</p>
          </motion.div>
        </div>

        {/* Developer Credit */}
        <div className="border-t-2 border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <motion.img 
                src="https://i.postimg.cc/9QGFv4L0/erasebg-transformed.png"
                alt="لوگو آرمان"
                className="h-14 w-14 bg-white rounded-full p-2"
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.6 }}
              />
              <div>
                <p className="text-gray-300 text-sm mb-1">طراحی و توسعه توسط</p>
                <motion.a
                  href="https://armandev.ir"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.05 }}
                  className="inline-flex items-center gap-2 font-bold text-xl text-secondary-400 hover:text-secondary-300 transition-all"
                >
                  تیم توسعه نرم‌افزاری آرمان
                  <FaExternalLinkAlt className="text-sm" />
                </motion.a>
              </div>
            </div>
            
            <div className="text-center md:text-left">
              <p className="text-gray-300 text-sm">
                © {new Date().getFullYear()} نوآفرین‌شو. تمامی حقوق محفوظ است.
              </p>
              <p className="text-gray-400 text-xs mt-1">
                سامانه ثبت طرح‌های فناور
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;